const textToChars = (text: string): number[] => text.split('').map((c) => c.charCodeAt(0));

const applySaltToChar =
  (salt: string) =>
  (code: number): number =>
    textToChars(salt).reduce((a: number, b: number) => a ^ b, code); // eslint-disable-line no-bitwise

export const crypt = (salt: string, text: string): string => {
  if (!salt || !text) return text ?? '';
  const byteHex = (n: number): string => `0${Number(n).toString(16)}`.substr(-2);

  return text
    .split('')
    .map((c: string) => c.charCodeAt(0))
    .map(applySaltToChar(salt))
    .map(byteHex)
    .join('');
};

export const decrypt = (salt: string, encoded: string): string => {
  if (!salt || !encoded) return encoded ?? '';
  const pairs: string[] = encoded.match(/.{1,2}/g) ?? [];
  return pairs
    .map((hex: string) => parseInt(hex, 16))
    .map(applySaltToChar(salt))
    .map((charCode: number) => String.fromCharCode(charCode))
    .join('');
};

